export default __webpack_public_path__ + "static/media/pag24.4a22d9d0.jpg";